import { Spinner, Radio, Checkbox } from "flowbite-react";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { notify } from 'react-notify-toast';
import { Drawer } from "../../components/Modals";
import { useResourcesService } from '../../services';
import moment from "moment";
import CustomButton from '../../components/common/CustomButton';

const UnassignedTaskModal = ({
            showUnassignedTaskModal,
            closeUnassignedTaskModal,
            selectedDate,
            assigneeGroup,
            groupAssignedTask
        }:any) =>{
        const [selectedTask, setSelectedTask] = useState<any>({})
        const [activeTab, setActiveTab] = useState("primary")
        
        const { getUnassignedTasks, saveAssignedTask } = useResourcesService();
        const {
                unassignedTasksLoading,
                unassignedTasksList,
                uatl,
                suggestedTasks
            } = useSelector((state: any) => state.resources);

        useEffect(()=>{
            if(selectedDate){
                getUnassignedTasks({
                    resource_id:assigneeGroup.id,
                    start_date:moment(selectedDate).format("YYYY-MM-DD"),
                    tasks:groupAssignedTask ? Object.values(groupAssignedTask) :[],
                })
            }
        },[])

        const handleTaskRadioButton = (e:any,task:any) =>{
            setSelectedTask(task)
        }

        const handleSaveClick = async () => {
            const isFetch = suggestedTasks?.resources
            if(!unassignedTasksLoading){
                if(selectedTask?.item_id){
                    await saveAssignedTask({
                        resource_id:assigneeGroup.id,
                        ...selectedTask
                    },isFetch)
                    closeUnassignedTaskModal()
                } else {
                    notify.show("Please choose a task to continue.", "error", 2000);
                }
                
            }
        }

        // Removed unused handleTabClick to satisfy linter and keep logic unchanged
        const handleAdditionalCheckbox = (e: any) => {
            const isChecked = e.target.checked;
            if(isChecked){
                setActiveTab("additional")
            } else {
                setActiveTab("primary")
            }
            
        }

    // Removed unused assignedTasks to satisfy linter and keep logic unchanged

    return (
        <Drawer
          isOpen={showUnassignedTaskModal}
          onClose={closeUnassignedTaskModal}
          position="right"
          minsize="40"
          size="40"
        >
            <div className="h-screen w-full flex flex-col bg-light-surface dark:bg-tertiary-dark overflow-hidden">
                <div className="flex-shrink-0 flex flex-row border-b z-50 rounded-b-2xl border-gray-400 dark:border-hover-dark bg-light-surfacePrimary dark:bg-tertiary-dark px-6 py-4 text-light-text-primary dark:text-white shadow-lg">
                    <div className="flex w-full items-center min-h-[60px]">
                        <div className="flex flex-col flex-1">
                            <div className="text-light-text-primary dark:text-white text-lg font-semibold capitalize">
                                <span className="text-blue-600 dark:text-blue-400">{assigneeGroup.title}</span>
                                <span className="ml-1">: Task Recommendations</span>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="text-light-text-secondary hover:text-light-text-primary dark:text-white/70 dark:hover:text-white hover:bg-light-interactive-hover dark:hover:bg-white/10 p-2 rounded-lg transition-colors duration-200"
                            onClick={closeUnassignedTaskModal}
                        >
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <div className="flex-1 overflow-y-auto bg-light-surface dark:bg-tertiary-dark">
                    {unassignedTasksLoading ? (
                        <div className="flex items-center justify-center h-full">
                            <Spinner aria-label="Loading..." size="xl" />
                        </div>
                    ) : (
                        <div className="px-16 py-8 space-y-6">
                            <label className="flex items-center gap-2 p-3 rounded-lg bg-blue-50 hover:bg-blue-100 dark:bg-blue-900/20 dark:hover:bg-blue-900/30 transition-colors cursor-pointer">
                                <Checkbox
                                    id="assignment"
                                    defaultChecked={activeTab === "additional"}
                                    className="!ring-0"
                                    onChange={handleAdditionalCheckbox}
                                />
                                <span className="text-gray-700 dark:text-gray-200 text-sm font-medium">
                                    Include tasks that need additional assignee
                                </span>
                            </label>

                            <div className="text-sm text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-800/40 p-4 rounded-lg border border-light-border-default dark:border-gray-700/50">
                                <span>Open tasks that </span>
                                <span className="text-blue-600 dark:text-blue-400 font-semibold">{assigneeGroup.title}</span>
                                <span> with their expertise could be assigned to in this time slot, organized by Cadence's recommendation:</span>
                            </div>

                            <div className="space-y-4">
                                <h3 className="text-light-text-primary dark:text-white text-base font-semibold border-b border-light-border-default dark:border-gray-700 pb-2">
                                    Needs Primary Assignee
                                </h3>

                                <div className="space-y-3">
                                    {(unassignedTasksList?.length > 0) ? (
                                        unassignedTasksList.map((task:any) => (
                                            <div key={task.item_id} className="flex items-start gap-3 p-3 rounded-lg bg-white hover:bg-blue-50 dark:bg-gray-800/40 dark:hover:bg-blue-900/30 border border-light-border-default hover:border-blue-300 dark:border-gray-700/50 dark:hover:border-blue-500/50 transition-all">
                                                <Radio
                                                    id={task.id}
                                                    name="assignedTask"
                                                    className="mt-1"
                                                    onChange={(e)=>handleTaskRadioButton(e,task)}
                                                />
                                                <div className="flex-1 min-w-0">
                                                    <div className="flex flex-wrap gap-1">
                                                        <span className="text-light-text-primary dark:text-white text-sm font-bold truncate">
                                                            {task?.project_name}:
                                                        </span>
                                                        <span className="text-light-text-primary dark:text-white text-sm truncate">
                                                            {task?.task_title}
                                                        </span>
                                                    </div>
                                                    <div className="text-light-text-secondary dark:text-gray-400 text-xs mt-1">
                                                        {task?.duration} days - {moment(task?.start).format("MMM DD YYYY")} - {moment(task?.end).format("MMM DD YYYY")}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-gray-500 dark:text-gray-400 text-sm italic p-4 text-center bg-gray-50 dark:bg-gray-800/20 rounded-lg">
                                            No primary tasks available
                                        </div>
                                    )}
                                </div>
                            </div>

                            {activeTab === "additional" && (
                                <div className="space-y-4">
                                    <h3 className="text-light-text-primary dark:text-white text-base font-semibold border-b border-light-border-default dark:border-gray-700 pb-2">
                                        Needs Additional Assignee
                                    </h3>

                                    <div className="space-y-3">
                                        {uatl.length > 0 ? (
                                            uatl.map((task:any) => (
                                                <div key={task.item_id} className="flex items-start gap-3 p-3 rounded-lg bg-white hover:bg-blue-50 dark:bg-gray-800/40 dark:hover:bg-blue-900/30 border border-light-border-default hover:border-blue-300 dark:border-gray-700/50 dark:hover:border-blue-500/50 transition-all">
                                                    <Radio
                                                        id={task.id}
                                                        name="assignedTask"
                                                        className="mt-1"
                                                        onChange={(e)=>handleTaskRadioButton(e,task)}
                                                    />
                                                    <div className="flex-1 min-w-0">
                                                        <div className="flex flex-wrap gap-1">
                                                            <span className="text-light-text-primary dark:text-white text-sm font-bold truncate" title={task?.project_name}>
                                                                {task?.project_name}:
                                                            </span>
                                                            <span className="text-light-text-primary dark:text-white text-sm truncate" title={task?.task_title}>
                                                                {task?.task_title}
                                                            </span>
                                                        </div>
                                                        <div className="text-light-text-secondary dark:text-gray-400 text-xs mt-1">
                                                            {task?.duration} days - {moment(task?.start).format("MMM DD YYYY")} - {moment(task?.end).format("MMM DD YYYY")}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="text-gray-500 dark:text-gray-400 text-sm italic p-4 text-center bg-gray-50 dark:bg-gray-800/20 rounded-lg">
                                                No additional tasks available
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="flex-shrink-0 px-8 py-4 items-center justify-between flex gap-6 border-t border-gray-500 rounded-t-md dark:border-hover-dark bg-light-surfacePrimary dark:bg-tertiary-dark shadow-lg">
                    <CustomButton
                        onClick={closeUnassignedTaskModal}
                        variant="cancel"
                   >
                        Cancel
                    </CustomButton>
                    <CustomButton
                        onClick={handleSaveClick}
                        disabled={unassignedTasksLoading}
                        isLoading={unassignedTasksLoading}
                      >
                        Save
                    </CustomButton>
                </div>
            </div>
        </Drawer>
    )
}

export default UnassignedTaskModal;